const defaultSettings = id => ({
    "organizationId" : id,
    "status" : "ACTIVE",
      "department": {
        "title": "Departments",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": "Group1",
            "label": "Group 1"
          },
          {
            "key": "Group2",
            "label": "Group 2"
          },
          {
            "key": "Group3",
            "label": "Group 3"
          },
          {
            "key": "Group4",
            "label": "Group 4"
          }
        ]
      },
      "roleTitle": {
        "title": "Role",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "General"
          },
          {
            "key": 1,
            "label": "Type 1"
          },
          {
            "key": 2,
            "label": "Type 2"
          },
          {
            "key": 3,
            "label": "Type 3"
          },
          {
            "key": 4,
            "label": "Type 4"
          },
          {
            "key": 5,
            "label": "Type 5"
          },
          {
            "key": 6,
            "label": "Type 6"
          },
          {
            "key": 7,
            "label": "Type 7"
          },  
        ]
      },
      "level": {
        "title": "Level",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "Level 0-3"
          },
          {
            "key": 1,
            "label": "Level 3+"
          },
          {
            "key": 2,
            "label": "Level 5+"
          },
          {
            "key": 3,
            "label": "Level 8+"
          },
          {
            "key": 4,
            "label": "Level 12+" 
          },
          {
            "key": 5,
            "label": "Level 15+"
          },
          {
            "key": 6,
            "label": "Level 18+"
          },
          {
            "key": 7,
            "label": "Level 21+"
          },
        ]
      },
      "numberOfDirectReports": {
        "title": "Number of Direct Reports",
        "type": "textbox",
        "format": "number",
        "values":[]
      },
      "performance": {
        "title": "Performance",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "Scale Not Configured"
          }
        ]
      },
      "potential": {
        "title": "Potential",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "Scale Not Configured"
          }
        ]
      },
      
      "relationship": {
        "title": "Relationships",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "Participant"
          },
      {
            "key": 1,
            "label": "Leader"
          },
      {
            "key": 2,
            "label": "Other"
          },
      {
            "key": 3,
            "label": "Add Configuration"
          }
        ]
      },
  "currency": {
        "title": "Currencies",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "XP"
          },
          {
            "key": 1,
            "label": "Gold"
          },
          {
            "key": 2,
            "label": "Knowledge"
          },
      {
            "key": 3,
            "label": "Hours"
          },
      {
            "key": 4,
            "label": "EUR"
          },
      {
            "key": 5,
            "label": "$"
          },
      {
            "key": 6,
            "label": "Digital Tokens"
          }
        ]
      },
  "marketProductType": {
        "title": "Product Types",
        "type": "dropdown",
        "format": "text",
        "values": [
          {
            "key": 0,
            "label": "Merchandize"
          },
          {
            "key": 1,
            "label": "Digital NFTs"
          },
          {
            "key": 2,
            "label": "Tokens"
          },
      {
            "key": 3,
            "label": "Vacation Time"
          },
      {
            "key": 4,
            "label": "3D Prints"
          },
      {
            "key": 5,
            "label": "Coupons"
          }
        ]
      }
  })

export default defaultSettings;